import React from 'react';
import Button from 'react-bootstrap-button-loader';

import Spinner from '../../../commonComponents/Spinner/Spinner';

const LOG_LABELS = {
  created: 'created',
  modified: 'modified',
  uploaded: 'PDF added',
  deleted: 'PDF deleted',
  chapter_added: 'chapter added',
  chapter_deleted: 'chapter deleted',
};

class ViewActivityModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      waiting: false,
    };
  }

  componentWillMount() {
    this.props.onLoad(this.props.id, this.props.isChapter);
  }

  getLogLabel(fileAction) {
    return LOG_LABELS[fileAction] || fileAction;
  }

  getAdminName(log) {
    if (!log.user) return 'no data';
    return `${log.user.name} ${log.user.lastName} (id:${log.user.id})`;
  }

  renderLogItem(log) {
    const label = this.getLogLabel(log.fileAction);
    const adminName = this.getAdminName(log);
    const date = new Date(log.createdAt).toLocaleString();

    return (
      <div className="log-item">
        <span>{`${date}  `}</span>
        <span>{`${adminName}  `}</span>
        <span>{`(ip:${log.ip})  `}</span>
        <span>{` ${label}  `}</span>
        {log.fileName && <span>{` ${log.fileName}  `}</span>}
      </div>
    );
  }

  render() {
    const { closeModal, waiting, isChapter } = this.props;

    // Sort logs by createdAt DESC (most recent first)
    const sortedLogs = this.props.logs
      ? [...this.props.logs].sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        )
      : [];

    return (
      <div className="simple-confirmation-component">
        <div className="card-block">
          <div className="createChapterTitle">
            View {isChapter ? 'chapter ' : 'book '} activity log
            <i className="fa fa-times fa-xs" onClick={closeModal} />
            <hr />
          </div>
          {waiting && <Spinner text="Loading activity logs" />}
          {!waiting && (
            <div className="text">
              {sortedLogs.length !== 0 &&
                sortedLogs.map((log, index) => this.renderLogItem(log, index))}
              {sortedLogs.length === 0 && (
                <div className="text-center">
                  There are no Activity logs registered for this{' '}
                  {isChapter ? 'chapter' : 'book'}.
                </div>
              )}
            </div>
          )}
          <br />
          {this.state.error ? (
            <div className="errors">{this.state.error}</div>
          ) : null}
          <div className="bottom-buttons">
            <Button className="btn btn-danger closeBtn" onClick={closeModal}>
              {' '}
              close
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewActivityModal;
